<input #inputElement matInput placeholder="Enter company name" [value]="inputText" [required]="required"
  (input)="onInputTextChange($event.target)" (focus)="onInputFocus()" (blur)="onInputBlur()" />

<ng-template #autocompleteTemplate>
  @if (companies$ | async; as companies) {
  <div class="autocomplete-wrapper">
    @if(companies.length > 0) {
    <div class="company-row">
      <div class="name">
        <mat-icon svgIcon="company"></mat-icon>
        {{ 'sharedDialogs.addNewCompanyAutocomplete.companiesInIdeal' | transloco }}
      </div>
      <div class="website"></div>
      <div class="deals">
        <div class="deals_flex-wrapper">
          <mat-icon svgIcon="handshake"></mat-icon>
          {{ 'sharedDialogs.addNewCompanyAutocomplete.deals' | transloco }}
        </div>
      </div>
      <div class="contacts">
        <div class="contacts_flex-wrapper">
          <mat-icon svgIcon="company_contacts"></mat-icon>
          {{ 'sharedDialogs.addNewCompanyAutocomplete.contacts' | transloco }}
        </div>
      </div>
    </div>
    }
    <div class="autocomplete-results">

      @for (company of companies; track trackCompany(company)) {
      <div class="company-row" (click)="onCompanySelected(company)">
        <div class="name">
          <div class="name_flex-wrapper">
            <span [innerHTML]="highlightMatch(company.name, inputValue())"></span>
            <small class="address" [innerHTML]="formattedAddress(company.offices?.[0]?.address)"></small>
          </div>
        </div>
        <div class="website">
          <a [href]="checkForHttp(company.website)" (click)="$event.stopPropagation()" target="_blank">{{ formatWebsite(company.website) ?? "--" }}</a>
        </div>
        <div class="deals">
          <div class="deals_flex-wrapper">
            <mat-icon svgIcon="handshake"></mat-icon>
            {{ company.deals ?? 0 }}
          </div>
        </div>
        <div class="contacts">
          <div class="contacts_flex-wrapper">
            <mat-icon svgIcon="company_contacts"></mat-icon>
            {{ company.contacts ?? 0 }}
          </div>
        </div>
      </div>
      }
    </div>
    <div class="manual-entry">
      <button mat-button [disabled]="!result() || isSearchInFlight() || hasConflictingCompanyName(companies)" (mousedown)="$event.preventDefault()"
        (click)="manualEntryStarted.emit(inputValue()); closeOverlay()">
        <mat-icon>add</mat-icon>
        {{ 'sharedDialogs.addNewCompanyAutocomplete.addCompany' | transloco }}
      </button>
      <span>{{ inputValue() }}</span>
    </div>
  </div>
  }
</ng-template>